import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import WGRPage from "../Monthly/wgr/wgr/WGRPage";
import LabourLedgerPage from "../Monthly/wgr/laboursubledger/lslPage";
import DSAPage from "../Monthly/dsa/dsaPage";
import IOHPage from "../Monthly/calculation/ioh/iohPage";
import POHPage from "../Monthly/calculation/poh/pohPage";
import C3Page from "../Monthly/calculation/C3/c3Page";
import C4Page from "../Monthly/calculation/C4/c4Page";
import C5Page from "../Monthly/calculation/C5/c5Page";
import C6Page from "../Monthly/calculation/C6/c6Page";
import C7Page from "../Monthly/calculation/C7/c7Page";
import C8Page from "../Monthly/calculation/C8/c8Page";
import C9Page from "../Monthly/calculation/C9/c9Page";

import CalPage from "../Monthly/generalReports/costAnalysisLabour/caLPage";
import CaSPage from "../Monthly/generalReports/costAnalysisStore/caSPage";
import DWSPage from "../Monthly/generalReports/demandWiseSummery/dwsPage";
import DWDPage from "../Monthly/generalReports/demandWiseTotals/dwdPage";
import RCPage from "../Monthly/generalReports/repaircost/rcPage";
import SSPage from "../Monthly/generalReports/storeshedule/ssPage";
import UOCharge from "../Monthly/generalReports/underovercharge/uocPage";

import JV5 from "../Monthly/jvreports/jv5/jv5Page";
import JV6 from "../Monthly/jvreports/jv6/jv6Page";
import JV7 from "../Monthly/jvreports/jv7/jv7Page";
import JVSUMMERY from "../Monthly/jvreports/jvsummery/jvsummeryPage";
import CAPJV from "../Monthly/jvreports/capJV/capjvPage";
import StoreJVList from "../Monthly/jvreports/JVSList/jvSListPage";
import LabourJVList from "../Monthly/jvreports/JVLList/jvLListPage";
import WorkshopAccount from "../Monthly/accountsReports/workshopaccount/wasummeryPage";
import Control1 from "../Monthly/accountsReports/control1/cont1Page";
import Control2 from "../Monthly/accountsReports/control2/cont2Page";
import Actual from "../Monthly/accountsReports/actualaccount/actualPage";
import Appraisal from "../quarterly/FinancialAppraisal/faPage";
import UnitCost from "../quarterly/unitcost/ucPage";
import UnitExp from "../quarterly/unitexp/uePage";


/**
 * Report configuration
 */
const REPORT_COMPONENTS = {
  1: WGRPage,
  2: WGRPage,
  3: LabourLedgerPage,
  4: DSAPage,
  5: IOHPage,
  6: POHPage,
  7: C3Page,
  8: C4Page,
  9: C5Page,
  10: C6Page,
  11: C7Page,
  12: C8Page,
  13: C9Page,
  14: CalPage,
  15: CaSPage,
  16: DWSPage,
  17: DWDPage,
  18: RCPage,
  19: SSPage,
  20: UOCharge,
  21: JV5,
  22: JV6,
  23: JV7,
  24: JVSUMMERY,
  25: CAPJV,
  26: StoreJVList,
  27: LabourJVList,
  28: WorkshopAccount,
  29: Control1,
  30: Control2,
  31: Actual,
  32: Appraisal,
  33: UnitCost,
  34:UnitExp,
};


export default function ReportViewer() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const ReportComponent = REPORT_COMPONENTS[Number(id)];

  const reportProps = {
    reportType: state?.reportType,
    title: state?.title,
    month: state?.month,
    year: state?.year,
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-start"
        sx={{ mb: 3 }}
        className="no-print"
      >
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Stack>

      {ReportComponent ? (
        <ReportComponent {...reportProps} />
      ) : (
        <h2>Report Not Found</h2>
      )}
    </>
  );
}